/**
 * El menu del catalogo en el telefono: un acordeon.
 *
 * En escritorio las categorias van al lado del riel (`MegaMenu`); en una
 * pantalla angosta no hay al lado, y ponerlas debajo de todas las lineas
 * obligaba a bajar hasta el fondo despues de elegir una. Aca cada linea abre
 * sus categorias justo debajo de ella, y tocarla otra vez las cierra.
 *
 * Todas las hojas estan en el marcado (las cerradas con `hidden`): son enlaces
 * de verdad a cada categoria y `aria-controls` siempre apunta a algo.
 */
import { useState } from 'react';
import { Link } from 'react-router-dom';

import type { LineaNavegacion } from '@bandu/compartido';

import { numero } from '../../utilidades/formato';
import { rutas } from '../../utilidades/rutas';
import { Icono } from '../comunes/Icono';
import { IconoLinea } from '../comunes/IconoLinea';

export interface MenuAcordeonProps {
  lineas: LineaNavegacion[];
  prefijo: string;
  alNavegar?: () => void;
}

export function MenuAcordeon({ lineas, prefijo, alNavegar }: MenuAcordeonProps) {
  const [abierta, setAbierta] = useState<number | null>(null);

  return (
    <ul className="acordeon-lineas">
      {lineas.map((linea) => {
        const expandida = linea.id === abierta;
        const idHoja = `${prefijo}-acordeon-${linea.id}`;

        return (
          <li key={linea.id}>
            <button
              type="button"
              className={expandida ? 'indice-linea activo' : 'indice-linea'}
              aria-expanded={expandida}
              aria-controls={idHoja}
              onClick={(evento) => {
                setAbierta(expandida ? null : linea.id);
                // Al cerrarse una hoja de mas arriba, la linea tocada sube y
                // puede quedar fuera de la vista: se la lleva al borde de
                // arriba, con sus categorias a la vista debajo.
                const boton = evento.currentTarget;
                if (!expandida) {
                  requestAnimationFrame(() => {
                    boton.scrollIntoView({ block: 'start' });
                  });
                }
              }}
            >
              <IconoLinea slug={linea.slug} className="indice-icono" />
              <span>{linea.nombre}</span>
              <span className="cuenta">{numero(linea.cantidadProductos)}</span>
              <Icono nombre="chevron" className="acordeon-flecha" />
            </button>

            <div className="acordeon-hoja" id={idHoja} hidden={!expandida}>
              <Link className="acordeon-todo" to={rutas.linea(linea.slug)} onClick={alNavegar}>
                Ver la linea completa
                <Icono nombre="flecha" />
              </Link>
              {linea.categorias.map((categoria) => (
                <Link
                  key={categoria.id}
                  className="indice-cat"
                  to={rutas.categoria(categoria.slug)}
                  onClick={alNavegar}
                >
                  <span>{categoria.nombre}</span>
                  <span className="n">{numero(categoria.cantidadProductos)}</span>
                </Link>
              ))}
            </div>
          </li>
        );
      })}
    </ul>
  );
}
